import React from 'react';
import ReactDOM from 'react-dom/client';  // Correct import for React 18
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import 'leaflet/dist/leaflet.css';


// Initialize the root element
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render the app
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// Performance measuring (optional)
reportWebVitals();
